/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs */

const en_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog-to-storefront pipeline`)
};

const ar_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خط من الكتالوج إلى المتجر`)
};

const bn_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যাটালগ-থেকে-স্টোর পাইপলাইন`)
};

const de_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog-zu-Storefront-Pipeline`)
};

const es_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline de catálogo a tienda`)
};

const fr_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline du catalogue à la boutique`)
};

const pt_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline de catálogo para loja`)
};

const zh_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录到店铺管道`)
};

const tr_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogdan mağazaya hat`)
};

const ru_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пайплайн от каталога к витрине`)
};

const pl_svc_ai_image_pod_automation_work_0_badge = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potok od katalogu do sklepu`)
};

/**
* | output |
* | --- |
* | "Catalog-to-storefront pipeline" |
*
* @param {Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_work_0_badge = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_work_0_badge(inputs)
	return en_svc_ai_image_pod_automation_work_0_badge(inputs)
});
export { svc_ai_image_pod_automation_work_0_badge as "svc_ai-image-pod-automation_work_0_badge" }